import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { PrepaidcaseService } from "./shared/prepaidcase.service";
import { LoanService } from "../../loan/shared/loan.service";
import { Savings } from "../../savings/shared/savings.model";
import { SavingsService } from "../../savings/shared/savings.service";

@Component({
  selector: 'app-prepaidcase',
  templateUrl: './prepaidcase.component.html',
  styleUrls: ['./prepaidcase.component.css']
})
export class PrepaidcaseComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  SavingsNo: number;
  readonlyTextBox: boolean = true;
  readonlySearchBox: boolean = false;
  Address: string;
  Name: string;
  savings: Savings;

  constructor(private loanService: LoanService,
    private savingsService: SavingsService,
    public prepaidcaseService: PrepaidcaseService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.SavingsNo = +  params['Id'];
    });

    this.resetForm();

    if (Number.isNaN(this.SavingsNo)) {
      this.prepaidcaseService.selectedPrepaidCase.Id = 0;
      // this.prepaidcaseService.selectedPrepaidCase.Flag = 2; // updating 
      this.prepaidcaseService.selectedPrepaidCase.Flag = 1;
      this.prepaidcaseService.selectedPrepaidCase.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.prepaidcaseService.selectedPrepaidCase.Id = +this.SavingsNo;
      this.prepaidcaseService.selectedPrepaidCase.SavingsId  = +this.SavingsNo;
      this.prepaidcaseService.selectedPrepaidCase.Flag = 2;
      this.prepaidcaseService.selectedPrepaidCase.IsActive = true;
      this.AddButtonText = "Edit & Save";
      this.readonlySearchBox = true;
      this.getDefaultCaseById();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.prepaidcaseService.selectedPrepaidCase = {
      Id: 0,
      SavingsId: null,
      PrepaidCaseDate: new Date().toString(),
      IsPrepaidCase: false,

      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: null,
      Flag: 0,
      ToDate: null,
    }

  }

  onSubmit(form: NgForm) {

    if (this.prepaidcaseService.selectedPrepaidCase.SavingsId != null) {
      this.prepaidcaseService.IUDPrepaidcase(this.prepaidcaseService.selectedPrepaidCase)
        .toPromise()
        .then(data => {
          this.router.navigate(['/prepaidcaselist']);
        })
    }
    else {

    }
  }

  public ClickSearch(event: any) {

    this.getSavingsDeatils(this.prepaidcaseService.selectedPrepaidCase.SavingsId);
  }

  getSavingsDeatils(SavingsId: any) {

    this.savings = new Savings();
    this.savings.Id = SavingsId;
    this.savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.savingsService.FetchSavingsById(this.savings)
      .toPromise()
      .then(data => {
        this.Address = data.Address;
        this.Name = data.CustomerName;
      })
      .catch(err => { console.log(err) });
  }

  getDefaultCaseById() {
    this.prepaidcaseService.FetchPrepaidcaseById(this.prepaidcaseService.selectedPrepaidCase)
      .toPromise()
      .then(data => {
        this.prepaidcaseService.selectedPrepaidCase.Id = data.Id;
        this.prepaidcaseService.selectedPrepaidCase.SavingsId = data.SavingsId;
        this.prepaidcaseService.selectedPrepaidCase.IsPrepaidCase = data.IsPrepaidCase;
        this.Address = data.CustomerAddress;
        this.Name = data.CustomerName;
        this.prepaidcaseService.selectedPrepaidCase.Flag = 2;
      })
  }

  ClickIsPrepaid(event: any) {

    this.prepaidcaseService.selectedPrepaidCase.IsPrepaidCase = event.target.checked;
  }

}
